import {Component} from '@angular/core';
import {MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {FormControl, Validators} from '@angular/forms';
import {DateValidator} from 'frontier/nucleus';
import {ConfirmIconButtonComponent} from 'frontier/browserkit/src/lib/components/confirm-icon-button/confirm-icon-button.component';
import {
  DateElementComponent
} from '../../components/control/form-control/dynamic-form/form-element/date-element/date-element.component';
import {DialogHeaderComponent} from 'frontier/browserkit/src/lib/components/dialog-header/dialog-header.component';

@Component({
  selector: 'lib-date-picker-dialog',
  templateUrl: './date-picker-dialog.component.html',
  styleUrl: './date-picker-dialog.component.css',
  standalone: true,
  imports: [DialogHeaderComponent, MatDialogContent, DateElementComponent, MatDialogActions, ConfirmIconButtonComponent]
})
export class DatePickerDialogComponent {
  dateForm: FormControl = new FormControl(null, [Validators.required, DateValidator.isoFormat]);

  constructor(
    public dialogRef: MatDialogRef<any>
  ) {
    this.dateForm.patchValue('');
  }

  confirm() {
    this.dialogRef.close(this.dateForm.value);
  }
}
